/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IoCloseSharp } from 'react-icons/io5';
import Holon from '../Buttons/holon';
import Dropdown from '../Buttons/dropdown';
import Store from '../../store/store';
import { resultCardId } from '../../utils/string';
import { openModal } from '../../actions/modalActions';
import modalTypes from '../../constants/modalTypes';
import { allows } from '../../utils/authorization';
import Default from '../../constants/defaults';

class ResultDetailsHeader extends React.Component {
  constructor(props) {
    super(props);
    const vrs = props.workPackage.result_type
      ? props.workPackage.result_type.type_attributes
      : {};
    this.state = {
      value: vrs.value,
      risk: vrs.risk,
      size: vrs.size
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.workPackage.id !== prevProps.workPackage.id ||
      this.props.workPackage.result_type.type_attributes !==
        prevProps.workPackage.result_type.type_attributes
    ) {
      const vrs = this.props.workPackage.result_type
        ? this.props.workPackage.result_type.type_attributes
        : { ...prevState };
      this.updateTypeAttributesValues(vrs);
    }
  }

  updateTypeAttributesValues = (vrs) => {
    this.setState({ ...vrs });
  };

  handleWorkPackageBlock = (blockStatus) => {
    const payload = { blocked: blockStatus };
    this.props.handleUpdate(payload);
  };

  handleWorkPackageDelete = () => {
    this.props.handleDelete(this.props.workPackage.id);
    this.props.onClose();
  };

  handleWorkPackageRemove = () => {
    this.props.handleRemove(this.props.workPackage.id, this.props.cadence);
  };

  handleWorkPackageRestore = () => {
    this.props.handleRestore(this.props.workPackage.id);
    this.props.onClose();
  };

  handleSelectChange = (event) => {
    event.preventDefault();
    const vrs = this.state;
    vrs[event.target.name] =
      event.target.value === '' ? null : event.target.value;
    const payload = {
      type_attributes: {
        value: vrs.value,
        risk: vrs.risk,
        size: vrs.size
      }
    };
    this.setState(vrs, () => {
      if (this.props.workPackage.id) {
        this.props.handleUpdate(payload);
      } else {
        this.setState(vrs, () =>
          this.props.handleTypeAttributes(payload.type_attributes)
        );
      }
    });
  };

  openParent = () => {
    const { workPackage } = this.props;

    if (workPackage.parent_id) {
      Store.dispatch(
        openModal(modalTypes.featureDetail, {
          id: workPackage.parent_id,
          fromChild: true
        })
      );
    }
  };

  filterResultValues = (values) =>
    Object.keys(values)
      .filter((key) => key <= Default.LIMIT_VRS_VALUE)
      .reduce((obj, key) => ({ ...obj, [key]: values[key] }), {});

  render() {
    const { value, risk, size } = this.state;
    let { options, type } = this.props;
    const { organizationLevelId, organizationLevels } = this.props;

    if (!type) {
      type = organizationLevels.find((ol) => ol.id === organizationLevelId)
        .name;
    }

    if (Object.keys(this.props.options).length < 1) {
      options = {
        value_defaults: { values: {} },
        risk_defaults: { values: {} },
        size_defaults: { values: {} }
      };
    }
    const { workPackage, selectedSpace, onClose, changeOrgLevel } = this.props;
    const allowEdit = allows('update', workPackage);
    const allowDelete = allows('destroy', workPackage);
    const allowRestore = allows('restore_work_packages', workPackage);
    const valueTitle = type === 'Defect' ? 'SEVERITY' : 'VALUE';
    const valueOptions =
      type === 'Defect'
        ? (options.severity_defaults && options.severity_defaults.values) || {}
        : (options.value_defaults &&
            this.filterResultValues(options.value_defaults.values)) ||
          {};
    const riskOptions =
      (options.risk_defaults &&
        this.filterResultValues(options.risk_defaults.values)) ||
      {};
    const sizeOptions =
      (options.size_defaults &&
        this.filterResultValues(options.size_defaults.values)) ||
      {};
    return (
      <div>
        <div className="col-sm-5">
          <div className="col-sm-1">
            <Dropdown
              blocked={workPackage.blocked}
              handleBlock={this.handleWorkPackageBlock}
              handleRemove={this.handleWorkPackageRemove}
              handleDelete={this.handleWorkPackageDelete}
              handleRestore={this.handleWorkPackageRestore}
              allowDelete={workPackage.id > 0 ? allowDelete : false}
              allowEdit={workPackage.id > 0 ? allowEdit : false}
              allowRestore={workPackage.id > 0 ? allowRestore : false}
              type={workPackage.sprint ? workPackage.result_type.kind : ''}
              deleted={workPackage.deleted_at}
              onClose={onClose}
              changeOrgLevel={changeOrgLevel}
              selectedSpace={selectedSpace}
              result={workPackage}
              dropdownType="Result"
            />
          </div>
          <div className="col-sm-2">
            <strong
              className={`modal-title ${workPackage.blocked ? 'red' : ''}`}
            >
              {resultCardId(workPackage)}
            </strong>
          </div>
          <div className="col-sm-8">
            <div className="hours">
              <span>Plan - {workPackage.estimate || 0.0}</span>
            </div>
            <div className="hours">
              <span>ToDo - {workPackage.estimate || 0.0}</span>
            </div>
          </div>
        </div>
        <div className="col-sm-2 text-center">
          {!!workPackage.parent_id && <Holon action={this.openParent} />}
        </div>
        <div className="col-sm-5 form-inline">
          <div className="col-sm-offset-1 vrs">
            <div className="selected">
              <select
                name="value"
                className="value"
                disabled={!allowEdit}
                value={value || `-${valueTitle}-`}
                onChange={this.handleSelectChange}
              >
                {valueOptions[value] ? (
                  <option value="">--Remove--</option>
                ) : (
                  <option value="">{valueTitle}</option>
                )}
                {Object.keys(valueOptions).map((key) => (
                  <option key={key} value={key}>
                    {valueOptions[key]}
                  </option>
                ))}
              </select>
            </div>
            <div className="selected">
              <select
                name="risk"
                className="risk"
                disabled={!allowEdit}
                value={risk || '-RISK-'}
                onChange={this.handleSelectChange}
              >
                {valueOptions[risk] ? (
                  <option value="">--Remove--</option>
                ) : (
                  <option value="">RISK</option>
                )}
                {Object.keys(riskOptions).map((key) => (
                  <option key={key} value={key}>
                    {riskOptions[key]}
                  </option>
                ))}
              </select>
            </div>
            <div className="selected">
              <div className="size-text">
                {valueOptions[size] ? `${size} Points` : 'SIZE'}
              </div>
              <select
                name="size"
                className="points"
                disabled={!allowEdit}
                value={size || '-SIZE-'}
                onChange={this.handleSelectChange}
                onFocus={this.handleFocus}
              >
                {valueOptions[size] ? (
                  <option value="">--Remove--</option>
                ) : (
                  <option value="">SIZE</option>
                )}
                {Object.keys(sizeOptions).map((key) => (
                  <option key={key} value={key}>
                    {sizeOptions[key]}
                  </option>
                ))}
              </select>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={this.props.onClose}
            >
              <IoCloseSharp size="2em" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ResultDetailsHeader.propTypes = {
  handleUpdate: PropTypes.func,
  handleRemove: PropTypes.func,
  handleDelete: PropTypes.func,
  onClose: PropTypes.func,
  handleTypeAttributes: PropTypes.func,
  workPackage: PropTypes.object,
  cadence: PropTypes.number,
  options: PropTypes.object
};

export default ResultDetailsHeader;
